import styled, { css } from 'styled-components';

const sizingStyles = css`
  ${({ callToAction, size, videoHeight }) => {
    const sharedStyles = videoHeight
      ? `height: ${videoHeight}px !important; width: 100%;`
      : callToAction
      ? 'height: 100%; width: auto;'
      : 'height: 100%; width: 100%;';

    if (size === 'Small') {
      return `
          max-width: 578px;
          ${sharedStyles}
        `;
    } else if (size === 'Medium') {
      return `
          max-width: 784px;
          ${sharedStyles}
        `;
    } else if (size === 'Large') {
      return `
          max-width: 990px;
          ${sharedStyles}
        `;
    } else {
      return `
        ${sharedStyles} 
      `;
    }
  }}
`;

const backgroundStyles = css`
  ${({ backgroundUrl, hasPlayed, isPlaying, inline }) => {
    return `
        background: url('${backgroundUrl}');
        background-position: center;
        background-size: cover;

        img, .w-video-wrapper {
          display: ${!inline ? 'none !important' : !isPlaying && !hasPlayed && 'none !important;'} 
        }
    `;
  }};
`;

const playButtonModeStyles = css`
  display: inline-block;
  height: 100px;
  width: 100px;

  img {
    display: none !important;
  }
`;

const WistiaWrapper = styled.div`
  ${({ showPlayButtonOnly }) => (showPlayButtonOnly ? playButtonModeStyles : sizingStyles)}
  ${({ backgroundUrl }) => backgroundUrl && backgroundStyles}
  ${({ showThumbnailOnly }) => showThumbnailOnly && 'pointer-events: none'};
  position: relative;

  .w-bottom-bar-lower {
    display: ${({ isPlaying }) => (isPlaying ? 'block' : 'none !important')};
  }

  .w-big-play-button {
    display: none !important;
  }

  .wistia_click_to_play {
    display: ${({ useImageSizing }) => (useImageSizing ? 'none' : 'block')};
  }
`;

export { WistiaWrapper };
